import { render, staticRenderFns } from "./Kma.vue?vue&type=template&id=4f2f23d4&"
import script from "./Kma.vue?vue&type=script&lang=js&"
export * from "./Kma.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Jenkins_Home\\workspace\\liveinfo3-front-user-dev\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4f2f23d4')) {
      api.createRecord('4f2f23d4', component.options)
    } else {
      api.reload('4f2f23d4', component.options)
    }
    module.hot.accept("./Kma.vue?vue&type=template&id=4f2f23d4&", function () {
      api.rerender('4f2f23d4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/dashboard/components/Kma.vue"
export default component.exports